
























































































import Vue from "vue";
import LoadingErrorable from "@/models/util/LoadingErrorable";
import IJob from "@/models/jobs/IJob";
import JobProvider from "@/api/JobProvider";

import SpriteIcon from "@/components/util/SpriteIcon.vue";
import Loader from "@/components/util/Loader.vue";
import JobStatScaling from "@/components/job/JobStatScaling.vue";
import UiString from "@/components/uistring/UiString.vue";
import SkillTree from "@/components/skill/SkillTree.vue";
import JobTree from "./JobTree.vue";
import BigErrorBox from "@/components/util/BigErrorBox.vue";

import { axiosErrorToString } from "@/helpers/AxiosErrorUtils";

interface IData {
    job: LoadingErrorable<IJob, any>;
}

export default Vue.extend({
    components: {
        BigErrorBox,
        Loader,
        SpriteIcon,
        JobStatScaling,
        UiString,
        SkillTree,
        JobTree,
    },
    props: {
        "jobId": {}
    },
    data(): IData {
        return {
            job: new LoadingErrorable(),
        };
    },
    watch: {
        jobId(newId, oldId) {
            this.fetchData();
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const id = Number(this.jobId);
            if (isNaN(id) || id <= 0) {
                this.job.startLoad();
                this.job.failed(`"${this.jobId}" is not a valid class ID`);
                return;
            }

            this.job.startLoad();
            JobProvider.getJob(id, true).then((job) => {
                // Guard against 200 responses with unexpected bodies (e.g. an
                // HTML page) — rendering such a value crashes the template
                if (!job || !job.name || !job.mainStatString) {
                    this.job.failed("Received an unexpected response for this class");
                    return;
                }
                this.job.done(job);
            }).catch((error: any) => {
                this.job.failed(axiosErrorToString(error));
            });
        },
        getBreadcrumb() {
            let ret = [];
            let j = this.job.value ? this.job.value.parentJob : null;
            while (j) {
                ret.push(j);
                j = j.parentJob;
            }

            return ret.reverse();
        },
        getBaseClassId() {
            if (!this.job.value) {
                return 0;
            }

            let ret = null;
            let j: IJob|null = this.job.value.parentJob || this.job.value;
            while (j) {
                ret = j;
                j = j.parentJob;
            }
            
            return ret ? ret.id : 0;
        },
        getClassType(): string {
            if (this.job.value) {
                const t = this.job.value.classType;
                switch (t) {
                    case 0:
                        return "";
                    case 1:
                        return "dark";
                    case 2:
                        return "light";
                    default:
                        return String(t);
                }
            }

            return "";
        },
    }

});
